import { render, staticRenderFns } from "./NewAppRelease.vue?vue&type=template&id=71ac55b9"
import script from "./NewAppRelease.vue?vue&type=script&lang=js"
export * from "./NewAppRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports